import React from 'react';
import PropTypes from 'prop-types';

function IconGrab({ size = 24, className, style, refGrab = null }) {
  return (
    <svg style={{ ...style, cursor: `grab`}} className={className} ref={refGrab} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12H21M3 6H21M3 18H21" stroke="#B3B3B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconGrab.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  refGrab: PropTypes.any
}

export default IconGrab;
